<script setup>
import { computed } from 'vue'
import { ProfilePicture } from '@components'

import { useAppointments } from '@store/appointments.js'
const $appointments = useAppointments()

import { useSettings } from '@store/settings'
const $settings = useSettings()

import { useCustomizer } from '@store/customizer.js'
const $customizer = useCustomizer()

const emit = defineEmits(['select'])

const props = defineProps({
    staff: {
        type: Object
    }
})

const selectStaff = (event) => {
    if (event.target.classList.contains('staff-details-link')) return

    emit('select', props.staff)
}

const staffImageClass = computed(() => {
    return `staff-image ${$customizer.isRounded ? '' : '!rounded-none'} ${$settings.customizer.staff.layout_type == 'grid01' ? '!h-[162px]' : '!h-[128px]'}`
})
</script>

<style lang="scss" scoped></style>

<template>
    <div @click.prevent="selectStaff($event)" class="staff-item" :title="staff.name" :class="{ 'border border-[#eaecf0] rounded-lg pl-3 pr-4 py-3': !$settings.customizer.staff.show_image }, { 'rounded-none': !$customizer.isRounded }">
        <div v-if="$settings.customizer.staff.show_image" class="staff-image-group" :class="{ 'active': $appointments.selectedStaff.staff_id === props.staff.staff_id }, { '!rounded-none': !$customizer.isRounded }">
            <ProfilePicture :name="props.staff.name" :img="props.staff.profile_image_url" :bgColor="props.staff.color" :textClass="staffImageClass" :imgClass="staffImageClass" />

            <router-link v-if="$settings.customizer.staff.show_details" :to="{ name: 'staff.profile', params: { staff_id: staff.staff_id } }" class="staff-details-link" :style="`color: ${$settings.customizer.design.brand_color} !important`">
                Details
            </router-link>
        </div>

        <div class="staff-name" :style="$customizer.subtitleStyle">{{ staff.name }}</div>
        <!-- <div class="staff-price" v-if="staff.price">+${{ staff.price }}</div> -->
    </div>
</template>
